.upload-form {
  &:hover .sbb-file-selector__dropzone-area {
    background: #eee;
  }
}
